import { render, staticRenderFns } from "./AddVendor.vue?vue&type=template&id=62064eb0&"
import script from "./AddVendor.vue?vue&type=script&lang=js&"
export * from "./AddVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports